import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMe, logout, revokeSelf } from '@/lib/api';
import { usePanelStore } from '@/features/panel/store/panel-store';

const ME_KEY = ['me'] as const;

export function useMe() {
  return useQuery({ queryKey: ME_KEY, queryFn: getMe });
}

// Acoplamento controlado com panel-store: state derivado da sessão de usuário
// (selectedLive, attachedLives) precisa zerar no logout/revoke pra não vazar
// pro próximo mod que logar na mesma aba (PR #155 review issue 1).
function clearUserScopedState() {
  usePanelStore.getState().clearPanelSession();
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearUserScopedState();
      qc.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}

export function useRevokeSelf() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: revokeSelf,
    onSuccess: () => {
      clearUserScopedState();
      qc.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}
